// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const GO_SEARCH = "H\u013eadaj";
export const SEO_BREADCRUMB_FORUM_SEARCH = "Vyh\u013ead\u00e1vanie";
export const SEO_TITLE_FORUM_SEARCH = "Vyh\u013ead\u00e1vanie vo f\u00f3rach";
